import { InitialDataWrapper } from '@/src/types';

export const initialDataWrapper: InitialDataWrapper = {
  error: undefined,
  data: undefined,
  state: 'initial',
};
